import React from "react";
import { makeStyles, Typography } from "@material-ui/core";
import { Field } from "formik";
import { TextField } from "formik-material-ui";

export default function CustomInput({ error, className, ...props }) {
  const classes = useStyle();
  return (
    <div className={`${classes.container} ${className}`}>
      <Field component={TextField} {...props} color="primary" variant="outlined" className={classes.input} />
      <Typography color="error" variant="caption" className={classes.error}>
        {error}
      </Typography>
    </div>
  );
}

const useStyle = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    position: "relative",
  },
  error: {
    marginLeft: theme.spacing(),
    position: "absolute",
    bottom: -18,
    left: 8,
  },
  input: {
    backgroundColor: "white",
    borderRadius: 12,
    "& .MuiInputLabel-outlined": {
      color: theme.palette.text.disabled,
    },
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      transform: "translate(12px, 10px) scale(0.8)",
      zIndex: 3,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      top: 0,
      "& > legend": {
        display: "none",
      },
    },
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "transparent",
      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
    },
    "& .MuiOutlinedInput-input:-webkit-autofill": {
      boxShadow: "0 0 0 30px white inset !important",
    },
    "& .MuiInputBase-root": {
      padding: theme.spacing(),
      paddingLeft: 0,
      height: 64,
      borderRadius: 12,
      margin: 0,

      "& div": {
        marginTop: 10,
      },
      "& fieldset": {
        border: "1px solid rgba(219, 223, 232, 0.4)",
      },
      "& > input": {
        zIndex: 2,
        fontSize: 16,
        paddingBottom: 5,
        marginLeft: theme.spacing(),
        paddingLeft: 5,
      },
      "& > textarea": {
        zIndex: 2,
        fontSize: 16,
        paddingBottom: 5,
        marginLeft: theme.spacing(),
        marginTop: theme.spacing(3),
        paddingLeft: 5,
      },
      "&::after": {
        border: "none",
      },
    },
    "& .MuiInputBase-multiline ": {
      height: "unset",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderWidth: "0px",
    },
    "& .MuiInputBase-root.Mui-focused": {
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.1)",
      border: `2px solid ${theme.palette.secondary.main}`,
      "& > input": {
        paddingBottom: 5,
      },
    },
    "& .MuiFormHelperText-root": {
      display: "none",
    },
  },
}));
